import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { EntityPagedRequestParameters, EntityOrderedRequestParameters, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Scr } from "src/app/model/scr.model";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { IntegracaoService } from "../../integracao.service";

@Component({
    selector: 'app-scr-listagem',
    templateUrl: 'scr-listagem.component.html',
    standalone: false
})
export class ScrListagemComponent {

  @Input() public scrs: Scr[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();

  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  constructor(
    private fileUtils: FileUtilsService,
    private integracaoService: IntegracaoService,
    private bnLoadingService: BnLoadingService) {

  }
  
  ngOnInit() {
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  exportarAnexo(scr: Scr) {
    this.bnLoadingService.bloqueiaTela();
    this.integracaoService.getAnexo(scr.id).subscribe((conteudo) => {
      this.fileUtils.exportarArquivo(scr.nomeArquivo, conteudo, FileUtilsService.APPLICATION_OCTEC);
      this.bnLoadingService.liberaTela();
    }, () => { this.bnLoadingService.liberaTela() });
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.scrs = this.scrs.sort((a, b) => {
      if (ord.sentido === 'asc') {
        return this.compara(a, b, ord.atributo);
      } else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
      return 0;
    } else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      } else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    const _index = prop.indexOf('.');
    if (_index > -1) {
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

}
